<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showPrintProgramacion"
      scrollable
      no-close-on-backdrop
      title="Cargar excel"
      cancel-variant="outline-secondary"
      @hidden="resetModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-group>
            <flat-pickr
              v-model="rangeDate"
              class="form-control"
              :config="{ mode: 'range' }"
              placeholder="Rango de fechas"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <template #modal-footer>
        <div class="w-100">
          <template v-if="!showLoading">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="primary"
              size="sm"
              class="float-right"
              @click="getPartidosImprimir"
            >
              <feather-icon icon="PrinterIcon" class="mr-50" />
              <span class="align-middle">Imprimir</span>
            </b-button>
          </template>
          <div v-if="showLoading" class="text-center mt-1">
            <b-spinner variant="primary" label="Text Centered" />
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import {
  BRow,
  BCol,
  //   BCardText,
  BButton,
  // BAlert,
  BSpinner,
  BFormGroup,
  //  xxx
} from 'bootstrap-vue'
import { URL, URL_CARNET } from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BRow,
    BCol,
    // BCardText,
    BButton,
    // BAlert,
    BSpinner,
    flatPickr,
    BFormGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    categoriaSeleccionada: Object,
  },
  setup(props, { emit }) {
    const rangeDate = ref(null)
    const errorMaximo = ref(null)
    const errorMessage = ref(null)
    const showLoading = ref(false)
    const { getApi } = apiCall()
    function separaFecha() {
      // console.log(rangeDate.value)
      let auxiliar = null
      if (rangeDate.value != null) {
        const arrayFechas = rangeDate.value.split('to')
        if (arrayFechas.length >= 2) {
          auxiliar = {
            valido: true,
            inicio: arrayFechas[0].trim(),
            fin: arrayFechas[1].trim(),
          }
        } else {
          auxiliar = {
            valido: false,
            inicio: null,
            fin: null,
          }
        }
      }

      return auxiliar
    }
    async function getPartidosImprimir() {
      const dataFecha = separaFecha()
      // console.log(dataFecha)
      // console.log(props.categoriaSeleccionada.value)
      // showOpciones.value = false
      if (dataFecha != null) {
        if (dataFecha.valido) {
          const path = `ApiFixture/partidosImprimeProgramacionImagen/${dataFecha.inicio}/${dataFecha.fin}`
          const data = await getApi(URL, path)
          emit('partidos', data)
          if (data.flag === 'si') {
            window.open(
              `${URL_CARNET}programacion.pdf?v=${Math.random() * 100}`,
              // eslint-disable-next-line
              '_blank',
            )
          } else {
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: 'No existe datos para imprimir',
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  solid: true,
                },
              },
              {
                position: 'bottom-center',
                // eslint-disable-next-line
              },
            )
          }
          // listPartidos.value = data.data
          // overlayPartidos.value = false
        }
      }
    }
    // async function getPartidosImprimir() {
    //   const dataFecha = separaFecha()
    //   // console.log(dataFecha)
    //   // console.log(props.categoriaSeleccionada.value)
    //   // showOpciones.value = false
    //   if (dataFecha != null) {
    //     if (dataFecha.valido) {
    //       const path = `ApiFixture/partidosImprimeProgramacion/${dataFecha.inicio}/${dataFecha.fin}/${props.categoriaSeleccionada.value}`
    //       const data = await getApi(URL, path)
    //       emit('partidos', data)
    //       if (data.flag === 'si') {
    //         window.open(
    //           `${URL_CARNET}programacion.pdf?v=${Math.random() * 100}`,
    //           // eslint-disable-next-line
    //           '_blank',
    //         )
    //       } else {
    //         this.$toast(
    //           {
    //             component: ToastificationContent,
    //             props: {
    //               title: 'No existe datos para imprimir',
    //               icon: 'AlertCircleIcon',
    //               variant: 'danger',
    //               solid: true,
    //             },
    //           },
    //           {
    //             position: 'bottom-center',
    //             // eslint-disable-next-line
    //           },
    //         )
    //       }
    //       // listPartidos.value = data.data
    //       // overlayPartidos.value = false
    //     }
    //   }
    // }
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      // emit('recargar', props.dataEquipo.id_equipo)
      // console.log('hidden')
      errorMessage.value = null
      errorMaximo.value = null
      showLoading.value = false
      rangeDate.value = null
      // initPlayer()
      //       this.$emit('closeModal', false)
    }
    return {
      rangeDate,
      errorMaximo,
      errorMessage,
      resetModal,
      showLoading,
      getPartidosImprimir,
    }
  },
}
</script>
